import axios from "axios";
import axiosInstance from "../axiosInstance";

export type StationTabType = "overview" | "sessions" | "chargers";

interface GetStationTabParams {
  tenantId: string;
  stationId: string;
  tab: StationTabType;
  startDate: string;
  endDate: string;
}

export const getStationsApi = async ({
  tenantId,
  stationId,
  tab,
  startDate,
  endDate,
}: GetStationTabParams) => {
  const response = await axiosInstance.get(
    `/api/stations/tenants/${tenantId}/stations/${stationId}/${tab}`,
    {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    }
  );

  return response.data;
};
